<template>
  <div>
    <div class="your-teachers">Your teachers</div>
    <div class="search-bar">
      <input type="text" class="search-input" placeholder="Search By Name" v-model="teacherFilter" />
      <div id="magnifying-glass"></div>
    </div>
    <div class="teachers-and-responses-container">
      <div
        class="all-teachers-relative-cotainer"
        :class="{ open: showingSidebar, close: !showingSidebar}"
      >
        <div class="all-teachers-side-bar">
          <div class="all-teachers-container">
            <div
              class="teacher"
              :class="{'teacher-selected': selectedTeacher.EmployeeId === teacher.EmployeeId}"
              v-for="teacher in sortedTeachers()"
              :key="teacher.EmployeeId"
              @click="() => {selectAndDisplay(teacher.EmployeeId)}"
            >
              <div
                v-if="displayThisTeacher(teacher.LastName, teacher.FirstName)"
              >{{`${teacher.LastName}, ${teacher.FirstName} ${teacher.responses.length > 0 ? `(&#10004;)`: ``}`}}</div>
            </div>
          </div>
          <div @click="toggleSideBar" class="open-hide-sidebar">{{`${showHideDirection}`}}</div>
        </div>
      </div>
      <div class="all-questions-container">
        <div class="question-container" v-for="question in questions" :key="question.QuestionID">
          <ShortAnswerQuestion
            v-if="question.QuestionType === 'short answer'"
            :question="question"
            :selectedTeacher="selectedTeacher"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShortAnswerQuestion from "./ShortAnswerQuestion.vue";
import LikertTypeQuestion from "./LikertTypeQuestion.vue";
export default {
  props: {
    questions: {
      type: Object,
      required: true
    },
    teachers: {
      type: Object,
      required: true
    }
  },
  components: {
    ShortAnswerQuestion,
    LikertTypeQuestion
  },
  data() {
    return {
      showingSidebar: true,
      selectedTeacher: { EmployeeId: "", responses: [] },
      teacherFilter: ""
    };
  },
  methods: {
    sortedTeachers() {
      return Object.values(this.teachers).sort((t1, t2) => {
        if (t1.responses.length > t2.responses.length) return -1;
        if (t1.responses.length < t2.responses.length) return 1;
        if (t1.LastName.toLowerCase() < t2.LastName.toLowerCase()) return -1;
        if (t1.LastName.toLowerCase() > t2.LastName.toLowerCase()) return 1;
        return 0;
      });
    },
    toggleSideBar() {
      this.showingSidebar = !this.showingSidebar;
    },
    selectAndDisplay(employeeId) {
      this.$set(
        this.selectedTeacher,
        "responses",
        this.teachers[employeeId]["responses"]
      );
      this.$set(this.selectedTeacher, "EmployeeId", employeeId);
    },
    displayThisTeacher(lastName, firstName) {
      return this.teacherFilter === "" ||
        (lastName + "" + firstName)
          .toLowerCase()
          .indexOf(this.teacherFilter.toLowerCase()) !== -1
        ? true
        : false;
    }
  },
  computed: {
    showHideDirection() {
      return this.showingSidebar ? " < " : " > ";
    }
  }
};
</script>

<style scoped>
.your-teachers {
  font-family: Arial;
  font-size: 1.25em;
  color: #2c557d;
  margin: 0.5em;
}
.search-bar {
  width: 12em;
  height: 2em;
  margin: 0.5em;
  border: 1px solid #2c557d;
  color: #9b9b9b;
  border-radius: 0.4em;
  display: flex;
  align-items: center;
}
.search-input {
  width: 85%;
  height: 90%;
  border: none;
  border-radius: 0.4em;
  padding-left: 0.25em;
}
#magnifying-glass {
  font-size: 1.75em; /* This controls the size. */
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  border: 0.1em solid #9b9b9b;
  position: relative;
  border-radius: 0.35em;
}
#magnifying-glass::before {
  content: "";
  display: inline-block;
  position: absolute;
  right: -0.25em;
  bottom: -0.1em;
  border-width: 0;
  background: #9b9b9b;
  width: 0.35em;
  height: 0.08em;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
}
.all-teachers-relative-cotainer {
  position: absolute;
  overflow: hidden;
  height: 50vh;
}
.open {
  width: 45vw;
}
.close {
  width: 1em;
}
.all-teachers-side-bar {
  position: absolute;
  background-color: white;
  z-index: 5;
  display: flex;
  width: 100%;
  height: 100%;
  border: 1px solid #2c557d;
  border-radius: 0.5em;
}
.open-hide-sidebar {
  height: 100%;
  background-color: #2c557d;
  width: 5vw;
  padding: 0 0.25em 0 0.25em;
  border-radius: 0.4em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}
.teacher {
  font-family: Arial;
  color: #000000;
  padding-left: 0.2em;
  padding-bottom: 0.5em;
}
.teacher-selected {
  color: #000000;
  font-weight: 700;
}
.teacher:hover {
  color: #000000;
  font-weight: 700;
  cursor: pointer;
}
.all-teachers-container {
  height: 100%;
  width: 40vw;
  overflow-y: scroll;
}
.all-questions-container {
  margin-left: 1em;
  width: 75vw;
}
@media only screen and (min-width: 1024px) {
  .open-hide-sidebar {
    display: none;
  }
  .all-teachers-container {
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    margin: 0.5em 0 0.5em 0;
    position: static;
  }
  .all-teachers-side-bar {
    background-color: white;
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 0.5em;
    border: none;
    position: static;
  }
  .all-teachers-relative-cotainer {
    position: static;
    overflow: hidden;
    height: 50vh;
    border: 1px solid #2c557d;
    border-radius: 0.5em;
  }
  .open,
  .close {
    width: 20vw;
  }
  .teachers-and-responses-container {
    display: flex;
  }
}
</style>